import { ScriptAdapter } from "./ScriptAdapter";
export class FacebookScriptAdapter extends ScriptAdapter {
    constructor() {
        super(...arguments);
        this._initialized = false;
    }
    init(data) {
    }
    initLazy() {
        this.isReady();
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id))
                return;
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
            fjs.parentNode.insertBefore(js, fjs);
        }(this._contextDocument, 'script', 'facebook-jssdk'));
    }
    isReady() {
        if (!this._ready) {
            this._ready = new Promise((resolve, reject) => {
                this._contextWindow['fbAsyncInit'] = () => {
                    resolve();
                };
            });
        }
        return this._ready;
    }
    appInit(appID) {
        return this.isReady().then(() => {
            if (!this._initialized) {
                this._initialized = true;
                logger.log('FB.init', appID);
                this.FB.init({
                    appId: appID,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.0'
                });
                this.FB.AppEvents.logPageView();
            }
        });
    }
    get FB() {
        return this._contextWindow['FB'];
    }
    reParse() {
        if (this.FB && this.FB.XFBML) {
            this.FB.XFBML.parse();
        }
    }
}
